module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/data-bg.26d489ce.png";